import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Payment,
  PeopleAltOutlined,
  Apartment,
  AccountBalanceWalletTwoTone,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { baseUrl } from "../../../services/config";
import { PiStudentFill } from "react-icons/pi";
import { FaUsersGear } from "react-icons/fa6";
import "./style.css";

const HeadOfficeDashboard = () => {
  const history = useHistory();
  const authtoken = localStorage.getItem("userToken");

  const [paidFee, setPaidFee] = useState(0);
  const [unpaidFee, setUnpaidFee] = useState(0);
  const [admitStudent, setAdmitStudent] = useState(0);
  const [stuckOffStudent, setStuckOffStudent] = useState(0);
  const [leavingStudent, setLeavingStudent] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);
  const [currentStudent, setCurrentStudent] = useState(0);
  const [totalFee, setTotalFee] = useState(0);
  const [averageFee, setAverageFee] = useState(0);
  const [totalConcession, setTotalConcession] = useState(0);
  const [noFeeStudent, setNoFeeStudent] = useState(0);
  const [lessThan2000Students, setLessThan2000Students] = useState(0);
  const [lessThan4500Students, setLessThan4500Students] = useState(0);
  const [aboveThan4500Students, setAboveThan4500Students] = useState(0);
  const [ConcessionName, setConcessionName] = useState([]);
  const [ConcessionStudent, setConcessionStudent] = useState([]);
  const [CampusEmpSalaries, setCampusEmpSalaries] = useState([]);
  const [CampusNameSalaries, setCampusNameSalaries] = useState([]);
  const [totalEmpSalaries, setTotalEmpSalaries] = useState(0);
  const [CampusEmployees, setCampusEmployees] = useState([]);
  const [CampusEmployeesName, setCampusEmployeesName] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [AccountTitle, setAccountTitle] = useState([]);
  const [FinalAmount, setFinalAmount] = useState([]);
  const [assignMessage, setAssignMessage] = useState(0);
  const [remainingMessage, setRemainingMessage] = useState(0);

  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
  }).format(new Date());

  useEffect(() => {
    getUnitMessages();
    getAllFee();
    getStudentStatus();
    getStudentLiableFeeGraph();
    getConcessionStudentGraph();
    getTotalEmployeesSalariesGraph();
    getTotalEmployeesGraph();
    getTotalAmountBalanceGraph();
  }, []);

  const abbrev_name = (str1) => {
    const split = str1.trim().split(" ");
    return split.length > 1 ? split[0] + " " + split[1].charAt(0) + "." : split[0];
  };

  const abbrev_bank = (str1) => {
    const split = str1.trim().split(" ");
    return split.length > 1 ? split[0] + " " + split[1] : split[0];
  };

  const getUnitMessages = async () => {
    await fetch(`${baseUrl}/get-unit-messages`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setAssignMessage(data?.payload?.assign_sms);
        setRemainingMessage(data?.payload?.remaining_sms);
      })
      .catch((err) => console.log("error: ", err));
  };

  const getAllFee = async () => {
    await fetch(`${baseUrl}/total_paid_unpaid_fee`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setPaidFee(data.payload.paid);
        setUnpaidFee(data.payload.unpaid);
      })
      .catch((err) => console.log("error: ", err));
  };

  const getStudentStatus = async () => {
    await fetch(`${baseUrl}/total-student-graph`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setTotalStudents(data.payload.total_students);
        setCurrentStudent(data.payload.current_students);
        setAdmitStudent(data.payload.admit_students);
        setStuckOffStudent(data.payload.stuckOff_students);
        setLeavingStudent(data.payload.leaving_students);
      })
      .catch((err) => console.log("error", err));
  };

  const getStudentLiableFeeGraph = async () => {
    await fetch(`${baseUrl}/student_liable_fee_graph`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setTotalFee(data.payload.totalFee);
        setAverageFee(data.payload.averageFee);
        setTotalConcession(data.payload.totalConcession);
        setNoFeeStudent(data.payload.noFeeStudent);
        setLessThan2000Students(data.payload.lessThan2000Students);
        setLessThan4500Students(data.payload.lessThan4500Students);
        setAboveThan4500Students(data.payload.aboveThan4500Students);
      })
      .catch((err) => console.log("error: ", err));
  };

  const getConcessionStudentGraph = async () => {
    await fetch(`${baseUrl}/total_concession_student_graph`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const names = [];
        const counts = [];
        for (let i = 0; i < data.payload.total_concession.length; i++) {
          names.push(abbrev_name(data.payload.total_concession[i].concession_name));
          counts.push(parseInt(data.payload.total_concession[i].concession_type));
        }
        setConcessionName(names);
        setConcessionStudent(counts);
      })
      .catch((err) => console.log("error: ", err));
  };

  const getTotalEmployeesSalariesGraph = async () => {
    await fetch(`${baseUrl}/total_employees_salaries_graph`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const names = [];
        const salaries = [];
        for (let i = 0; i < data.payload.campus_salaries_data.length; i++) {
          names.push(abbrev_name(data.payload.campus_salaries_data[i].campus_name));
          salaries.push(parseInt(data.payload.campus_salaries_data[i].campus_salary));
        }
        setCampusNameSalaries(names);
        setCampusEmpSalaries(salaries);
        setTotalEmpSalaries(parseInt(data.payload.total_employees_salaries));
      })
      .catch((err) => console.log("error: ", err));
  };

  const getTotalEmployeesGraph = async () => {
    await fetch(`${baseUrl}/total_employees_graph`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const names = [];
        const employees = [];
        for (let i = 0; i < data.payload.campus_employee_data.length; i++) {
          names.push(abbrev_name(data.payload.campus_employee_data[i].campus_name));
          employees.push(parseInt(data.payload.campus_employee_data[i].campus_employee));
        }
        setCampusEmployeesName(names);
        setCampusEmployees(employees);
        setTotalEmployees(data.payload.total_employees);
      })
      .catch((err) => console.log("error: ", err));
  };

  const getTotalAmountBalanceGraph = async () => {
    await fetch(`${baseUrl}/total_amount_balance`, {
      method: "GET",
      headers: { Authorization: `Bearer ${authtoken}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const titles = [];
        const amounts = [];
        for (let i = 0; i < data.payload.total_account_balance.length; i++) {
          titles.push(abbrev_bank(data.payload.total_account_balance[i].account_title));
          amounts.push(parseInt(data.payload.total_account_balance[i].final_amount));
        }
        setAccountTitle(titles);
        setFinalAmount(amounts);
      })
      .catch((err) => console.log("error: ", err));
  };

  // ── Shared styles ──────────────────────────────────────────────────────────

  const actionCardBase = (grad) => ({
    background: grad,
    borderRadius: 14,
    padding: "24px 16px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    gap: 10,
    boxShadow: "0 4px 20px rgba(0,0,0,0.14)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    minHeight: 120,
    userSelect: "none",
  });

  const chartBox = {
    background: "#fff",
    borderRadius: 14,
    padding: "22px 20px",
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
  };

  const kpiCard = (color) => ({
    background: "#fff",
    borderRadius: 12,
    padding: "18px 20px",
    borderLeft: `4px solid ${color}`,
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
  });

  // ── Common ApexCharts options ──────────────────────────────────────────────

  const donutOpts = (labels, colors) => ({
    chart: {
      fontFamily: "'Segoe UI', Roboto, sans-serif",
      toolbar: { show: false },
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 650,
      },
    },
    labels,
    colors,
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        shadeIntensity: 0.2,
        inverseColors: false,
        opacityFrom: 0.96,
        opacityTo: 0.86,
        stops: [0, 90, 100],
      },
    },
    legend: {
      position: "bottom",
      fontSize: "12px",
      fontWeight: 700,
      horizontalAlign: "center",
      markers: { radius: 8, width: 9, height: 9 },
      itemMargin: { horizontal: 10, vertical: 6 },
      labels: { colors: "#64748b" },
    },
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "72%",
          labels: {
            show: true,
            name: {
              show: true,
              color: "#64748b",
              fontSize: "12px",
              fontWeight: 700,
              offsetY: -4,
            },
            value: {
              show: true,
              color: "#0f172a",
              fontSize: "23px",
              fontWeight: 800,
              offsetY: 4,
              formatter: (value) => Number(value).toLocaleString(),
            },
            total: {
              show: true,
              color: "#0f172a",
              fontSize: "22px",
              fontWeight: 800,
              label: "Total",
              formatter: (w) =>
                w.globals.seriesTotals
                  .reduce((total, value) => total + value, 0)
                  .toLocaleString(),
            },
          },
        },
      },
    },
    dataLabels: { enabled: false },
    stroke: { colors: ["#ffffff"], width: 4 },
    tooltip: {
      fillSeriesColor: false,
      theme: "light",
      y: {
        formatter: (value) => Number(value).toLocaleString(),
      },
    },
    states: {
      hover: { filter: { type: "lighten", value: 0.04 } },
      active: { filter: { type: "none" } },
    },
    responsive: [
      {
        breakpoint: 768,
        options: {
          chart: { height: 250 },
          legend: { itemMargin: { horizontal: 6, vertical: 4 } },
        },
      },
    ],
  });

  const barOpts = (categories, color, gradColor, yFormatter) => ({
    chart: { toolbar: { show: false }, fontFamily: "'Segoe UI', sans-serif" },
    xaxis: { categories, labels: { style: { fontSize: "11px", colors: "#888" } }, axisBorder: { show: false }, axisTicks: { show: false } },
    yaxis: { labels: { formatter: yFormatter, style: { fontSize: "11px", colors: "#aaa" } } },
    colors: [color],
    fill: {
      type: "gradient",
      gradient: { shade: "light", type: "vertical", shadeIntensity: 0.35, gradientToColors: [gradColor], stops: [0, 100] },
    },
    plotOptions: { bar: { borderRadius: 6, columnWidth: "50%", borderRadiusApplication: "end" } },
    grid: { borderColor: "#f5f5f5", strokeDashArray: 4, yaxis: { lines: { show: true } }, xaxis: { lines: { show: false } } },
    dataLabels: { enabled: false },
    states: { hover: { filter: { type: "lighten", value: 0.1 } } },
  });

  // ── Render ─────────────────────────────────────────────────────────────────

  const smsUsed = Math.max(Number(assignMessage || 0) - Number(remainingMessage || 0), 0);
  const smsRemainingPercent = assignMessage
    ? Math.round((Number(remainingMessage || 0) / Number(assignMessage)) * 100)
    : 0;
  const smsUsedPercent = assignMessage
    ? Math.round((smsUsed / Number(assignMessage)) * 100)
    : 0;

  return (
    <div className="head-office-dashboard" style={{ fontFamily: "'Segoe UI', Roboto, sans-serif" }}>

      {/* ── Quick Actions ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14, marginBottom: 24 }}>
        {[
          { Icon: Payment,                   label: "Receive Fee",       path: "/receivepartialfee",  grad: "linear-gradient(135deg,#121291 0%,#4343ff 100%)" },
          { Icon: PeopleAltOutlined,          label: "Print Fee Bill",    path: "/student-wise-print", grad: "linear-gradient(135deg,#1a6b3a 0%,#27ae60 100%)" },
          { Icon: Apartment,                  label: "Add Voucher",       path: "/account_vocher",     grad: "linear-gradient(135deg,#b05c00 0%,#f39c12 100%)" },
          { Icon: AccountBalanceWalletTwoTone, label: "Students Due Fee", path: "/due-fee",            grad: "linear-gradient(135deg,#a01020 0%,#e63946 100%)" },
          { Icon: PiStudentFill,              label: "Find Student",      path: "/findstudent",        grad: "linear-gradient(135deg,#5b0080 0%,#8e44ad 100%)" },
          { Icon: FaUsersGear,                label: "Find Staff",        path: "/searchstaff",        grad: "linear-gradient(135deg,#006070 0%,#00b4d8 100%)" },
        ].map(({ Icon, label, path, grad }) => (
          <div
            key={label}
            onClick={() => history.push(path)}
            style={actionCardBase(grad)}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 14px 36px rgba(0,0,0,0.22)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)";    e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.14)"; }}
          >
            <Icon style={{ fontSize: 38, color: "#fff" }} />
            <span style={{ fontWeight: 600, fontSize: 14 }}>{label}</span>
          </div>
        ))}
      </div>

      {/* ── KPI Stats ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 14, marginBottom: 24 }}>
        {[
          { label: "Current Students",  value: currentStudent,                              color: "#121291" },
          { label: "Paid Fee (PKR)",    value: Number(paidFee).toLocaleString(),            color: "#27ae60" },
          { label: "Unpaid Fee (PKR)",  value: Number(unpaidFee).toLocaleString(),          color: "#e63946" },
          { label: "Total Employees",   value: totalEmployees,                              color: "#f39c12" },
          { label: "Avg Fee (PKR)",      value: Number(averageFee).toLocaleString(),         color: "#8e44ad" },
        ].map(({ label, value, color }) => (
          <div key={label} style={kpiCard(color)}>
            <div style={{ fontSize: 22, fontWeight: 700, color, lineHeight: 1.2 }}>{value || "—"}</div>
            <div style={{ fontSize: 12, color: "#999", marginTop: 6 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* ── Row 1: Fee Collection & Student Strength ── */}
      <div className="unit-message-card">
        <div className="unit-message-main">
          <span>Total Unit Messages</span>
          <strong>{Number(assignMessage || 0).toLocaleString()}</strong>
          <small>Total messages assigned to this unit</small>
        </div>
        <div className="unit-message-details">
          <div className="unit-message-stat assigned">
            <span>Assigned</span>
            <strong>{Number(assignMessage || 0).toLocaleString()}</strong>
          </div>
          <div className="unit-message-stat remaining">
            <span>Remaining</span>
            <strong>{Number(remainingMessage || 0).toLocaleString()}</strong>
          </div>
          <div className="unit-message-stat used">
            <span>Used</span>
            <strong>{smsUsed.toLocaleString()}</strong>
          </div>
        </div>
        <div className="unit-message-progress">
          <div>
            <span>Remaining balance</span>
            <strong>{smsRemainingPercent}%</strong>
          </div>
          <div className="message-meter">
            <i style={{ width: `${smsRemainingPercent}%` }} />
          </div>
          <small>{smsUsedPercent}% consumed</small>
        </div>
      </div>

      <div className="graphs-section-heading">
        <div>
          <span>Analytics Overview</span>
          <h4>Graphs Data</h4>
        </div>
        <small>Fee, student strength, staff and account insights</small>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Fee Collection</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>{formattedDate}</div>
          <Chart
            type="donut"
            height={280}
            series={[Number(unpaidFee), Number(paidFee)]}
            options={{
              ...donutOpts(["Unpaid Fee", "Paid Fee"], ["#e63946", "#121291"]),
              tooltip: { y: { formatter: (v) => `PKR ${Number(v).toLocaleString()}` } },
            }}
          />
        </div>

        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Student Strength</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>Total enrolled: {totalStudents}</div>
          <Chart
            type="donut"
            height={280}
            series={[Number(admitStudent), Number(currentStudent), Number(stuckOffStudent), Number(leavingStudent)]}
            options={donutOpts(
              ["New Admission", "Prev-Admission", "Stuck Off", "Leaving"],
              ["#121291", "#27ae60", "#f39c12", "#e63946"]
            )}
          />
        </div>
      </div>

      {/* ── Row 2: Campus Salaries & Employee Count (bar charts) ── */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Campus Gross Salaries</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>
            Total: PKR {Number(totalEmpSalaries).toLocaleString()}
          </div>
          <Chart
            type="bar"
            height={280}
            series={[{ name: "Salary (PKR)", data: CampusEmpSalaries }]}
            options={{
              ...barOpts(CampusNameSalaries, "#121291", "#6666ff", (v) => `${(v / 1000).toFixed(0)}k`),
              tooltip: { y: { formatter: (v) => `PKR ${Number(v).toLocaleString()}` } },
            }}
          />
        </div>

        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Campus Employee Count</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>
            Total: {totalEmployees} employees
          </div>
          <Chart
            type="bar"
            height={280}
            series={[{ name: "Employees", data: CampusEmployees }]}
            options={{
              ...barOpts(CampusEmployeesName, "#27ae60", "#82e0aa", (v) => v),
              tooltip: { y: { formatter: (v) => `${v} employees` } },
            }}
          />
        </div>
      </div>

      {/* ── Row 3: Fee Concession & Bank Balances ── */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Fee Concession Breakdown</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>
            Avg Fee: {averageFee} &nbsp;·&nbsp; Total Concession: {Number(totalConcession).toLocaleString()}
          </div>
          <Chart
            type="donut"
            height={280}
            series={[Number(noFeeStudent), Number(lessThan2000Students), Number(lessThan4500Students), Number(aboveThan4500Students)]}
            options={donutOpts(
              ["No Fee", "Up to 2,000", "2,001 – 4,500", "Above 4,500"],
              ["#4e6e29", "#f39c12", "#e67e22", "#e63946"]
            )}
          />
        </div>

        <div style={chartBox}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Bank Account Balances</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>Balance per account (PKR)</div>
          <Chart
            type="bar"
            height={280}
            series={[{ name: "Balance (PKR)", data: FinalAmount }]}
            options={{
              ...barOpts(AccountTitle, "#8e44ad", "#bb8fce", (v) => `${(v / 1000).toFixed(0)}k`),
              tooltip: { y: { formatter: (v) => `PKR ${Number(v).toLocaleString()}` } },
            }}
          />
        </div>
      </div>

      {/* ── Concession Student Types ── */}
      {ConcessionStudent.length > 0 && (
        <div style={{ ...chartBox, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, color: "#3a3a5c", fontSize: 15 }}>Concession Student Types</div>
          <div style={{ fontSize: 12, color: "#aaa", marginBottom: 14, marginTop: 2 }}>Distribution by concession category</div>
          <Chart
            type="bar"
            height={260}
            series={[{ name: "Students", data: ConcessionStudent }]}
            options={{
              ...barOpts(ConcessionName, "#e63946", "#f1948a", (v) => v),
              tooltip: { y: { formatter: (v) => `${v} students` } },
            }}
          />
        </div>
      )}

    </div>
  );
};

export default HeadOfficeDashboard;
